import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";

export const Datenschutz = () => {
  const [lang, setLang] = useState("de");

  return (
    <section className="datenschutz" style={{ padding: "160px 0", color: "#fff" }}>
      <Container>
        {/* Title & language buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "40px",
            flexWrap: "wrap",
          }}
        >
          <h2 style={{ marginBottom: "10px" }}>
            {lang === "en" ? "Privacy Policy" : "Datenschutzerklärung"}
          </h2>

          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              variant={lang === "de" ? "light" : "outline-light"}
              size="sm"
              onClick={() => setLang("de")}
            >
              Deutsch
            </Button>
            <Button
              variant={lang === "en" ? "light" : "outline-light"}
              size="sm"
              onClick={() => setLang("en")}
            >
              English
            </Button>
          </div>
        </div>

        {/* Content changes based on lang */}
        {lang === "de" ? (
          <>
            <p><strong>1. Überblick</strong></p>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert,
              wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>

            <p><strong>2. Datenerfassung auf dieser Website</strong></p>
            <p>
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten
              können Sie dem Impressum dieser Website entnehmen.
            </p>

            <p><strong>Wie erfassen wir Ihre Daten?</strong><br />
              Ihre Daten werden dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich um Daten handeln,
              die Sie in das Kontaktformular eingeben.
            </p>

            <p><strong>Wofür nutzen wir Ihre Daten?</strong><br />
            Wir erfassen Daten in erster Linie, um auf Ihre Anfragen zu antworten, mit Ihnen zu kommunizieren und Ihnen gewünschte Informationen oder Leistungen bereitzustellen. 
            </p>

            <p><strong>3. Ihre Rechte</strong><br />
              Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten.
              Sie haben außerdem das Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.
            </p>
          </>
        ) : (
          <>
            <p><strong>1. Overview</strong></p>
            <p>
              The following information gives a simple overview of what happens to your personal data
              when you visit this website. Personal data is any data that can be used to identify you personally.
            </p>

            <p><strong>2. Data Collection on this Website</strong></p>
            <p>
              Data processing on this site is carried out by the website operator. His contact details can be found in the legal disclosure (Impressum).
            </p>

            <p><strong>How do we collect your data?</strong><br />
            Some data is collected when you provide it to us, for example the information you enter on the contact form.
            </p>

            <p><strong>What do we use your data for?</strong><br />
              We primarily collect data so we can respond to your inquiries, communicate with you, and provide any information or services you request.
            </p>

            <p><strong>3. Your Rights</strong><br />
              You always have the right to receive free information about the origin, recipient, and purpose of your stored personal data.
              You also have the right to request correction or deletion of this data.
            </p>
          </>
        )}
      </Container>
    </section>
  );
};
